import { useCallback, useRef, useState } from 'react'
import { GrossMassValidationResult } from '../../consignment/models/request'

type Resolver = (value: boolean) => void

interface GrossMassValidationState {
  result: GrossMassValidationResult
}

function useGrossMassValidationConfirmation() {
  const [state, setState] = useState<GrossMassValidationState | null>(null)
  const resolverRef = useRef<Resolver | null>(null)

  const createResolver = useCallback((
    result: GrossMassValidationResult,
  ): Promise<boolean> => new Promise<boolean>((resolve) => {
    resolverRef.current = resolve
    setState({ result })
  }), [])

  const resolve = useCallback((value: boolean) => {
    setState(null)
    if (resolverRef.current) {
      resolverRef.current(value)
      resolverRef.current = null
    }
  }, [])

  const reject = useCallback(() => {
    resolve(false)
  }, [resolve])

  const confirm = useCallback(() => {
    resolve(true)
  }, [resolve])

  return {
    checkGrossMass: createResolver,
    result: state?.result ?? null,
    isOpen: state !== null,
    confirm,
    reject,
  }
}

export default useGrossMassValidationConfirmation
